// src/App.js
import React from 'react';
import MapComponent from '../components/MapComponent'

function MapSite() {
    return (
        <MapComponent />
    );
}

export default MapSite;
